import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * 手动自定义发送
 * 需要手动发送perf 使用 ， 便于特殊页面（比如预渲染）自定义性能数据
 * new LegoPerformance().set({}).send()
 */
import { setData, sendData } from "./core/performance/index";
import { uuid as _uuid, startMeasure as _startMeasure, endMeasure as _endMeasure, isSupported } from "./utils/measure";
import { initPreRenderMeasure } from "./core/jobs/base";
var defaultMaxVal = 10 * 1000; // 最大阈值 10s

var defaultOpt = {
  forbidFmp: true
};
export var LegoPerformance = /*#__PURE__*/function () {
  function LegoPerformance() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOpt;
    _classCallCheck(this, LegoPerformance);
    _defineProperty(this, "hasSend", void 0);
    _defineProperty(this, "forbidFmp", void 0);
    _defineProperty(this, "mark", void 0);
    this.hasSend = false;
    this.forbidFmp = options.forbidFmp;
    this.init();
  }
  _createClass(LegoPerformance, [{
    key: "init",
    value: function init() {
      if (this.forbidFmp) {
        // 禁用 fmp 默认发送
        window.ZZ_LEGO_PERF_SYMBOL && window.ZZ_LEGO_PERF_SYMBOL.forbidSendFmp();
      }
      return this;
    }
  }, {
    key: "send",
    value: function send() {
      var _this = this;
      try {
        if (document.readyState === 'complete') {
          this.mark = 'readyState';
          this.legoSend(); // 如果当前页面状态 dom 准备好了，直接触发 send
        } else {
          window.addEventListener(
          // 页面加载完毕  // 大部分都走 onload 触发
          'load', function () {
            _this.mark = 'load';
            _this.legoSend();
          }, true);
        }
      } catch (error) {}
    }
  }, {
    key: "legoSend",
    value: function legoSend() {
      if (this.hasSend) return;
      // 设置数据
      setData({
        mark: this.mark
      }, true);
      // 发送 lego 数据
      sendData({});
      this.hasSend = true;
    }

    // 开启平台侧体验度量
  }, {
    key: "set",
    value: function set() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      setData(_objectSpread({}, params), true);
      if (params.openMeasure) {
        initPreRenderMeasure();
      }
      return this;
    }
  }, {
    key: "uuid",
    value: function uuid() {
      return _uuid();
    }
  }, {
    key: "markTime",
    value: function markTime() {
      var startTimestamp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (!isSupported()) return;
      if (!startTimestamp) {
        console.log('[lego-performance]: 起始时间为 navigationStart', performance.timing.navigationStart);
        return fix(+new Date() - performance.timing.navigationStart, defaultMaxVal); //
      }
      console.log('[lego-performance]: 起始时间为自定义 timestamp', startTimestamp);
      return fix(+new Date() - startTimestamp, defaultMaxVal);
    }
    // 首屏时间自定义打点
  }, {
    key: "markFMP",
    value: function markFMP() {
      var startTimestamp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var t = this.markTime(startTimestamp);
      setData({
        fmp: t,
        atfTime: t
      }, true);
      return t;
    }
  }, {
    key: "markLoadTime",
    value: function markLoadTime() {
      var startTimestamp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var t = this.markTime(startTimestamp);
      setData({
        loadTime: t
      }, true);
      return t;
    }
  }, {
    key: "startMeasure",
    value: function startMeasure(uid, type) {
      return _startMeasure(uid, type);
    }
  }, {
    key: "endMeasure",
    value: function endMeasure(uid, type) {
      return _endMeasure(uid, type);
    }
  }]);
  return LegoPerformance;
}();
function fix(num) {
  var upper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
  var lower = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  num = Number.isNaN(num) ? 0 : num;
  return Math.min(Math.max(num, lower), upper);
}
if (typeof window !== 'undefined') {
  window.$LegoPerformance = LegoPerformance;
}